<template>
  <div v-if="isBankPop" class="popFixed">
    <div class="masking" @click="closeBankPop" />
    <div class="tcCon">
      <div class="item">
        <span>温馨提示</span>
        <p>为了您的账户资金安全</p>
        <p>首次存款请先添加一张银行卡或电子钱包</p>
      </div>
      <div class="btnCon">
        <span @click="goAddBankCard">添加银行卡</span>
        <span style="font-weight: normal" @click="goAddWallet">添加电子钱包</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoBankPop',
  props: ['source', 'isBankPop'],
  data() {
    return {
      isShow: this.isBankPop
    }
  },
  mounted() {
    this.addFixed()
  },
  methods: {
    addFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.add('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    closeBankPop() {
      if (this.source == 'home') {
        this.toggleFixed()
        this.isShow = false
        this.$emit('changeBank', this.isShow)
      }
    },
    goAddBankCard() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/addBankCard', query: { bankType: 1 }})
    },
    goAddWallet() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/RegisterUSDT', query: { toDeposit: 1 }})
    }
  }
}
</script>
